import { Navigate } from "react-router-dom";
import { useUser } from "./userProvider";

export const Auth = ({ children, allowedRoles }) => {
  const { user, isLoading, isAuthenticated } = useUser();

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated || !user) {
    // console.warn("Auth: User not authenticated, redirecting to login");
    return <Navigate to="/" replace />;
  }

  // If allowedRoles is specified, check if user has required role
  if (allowedRoles && allowedRoles.length > 0) {
    const hasRequiredRole = allowedRoles.includes(user.role);

    // console.log("Auth: Role verification", {
    //   userRole: user.role,
    //   allowedRoles,
    //   hasRequiredRole,
    // });

    if (!hasRequiredRole) {
      // console.error(
      //   `Auth: Access Denied - User role '${user.role}' not in allowed roles:`,
      //   allowedRoles
      // );
      return <Navigate to="/" replace />;
    }
  }

  // User is authenticated and authorized
  // console.log("Auth: Access granted for role:", user.role);
  return children;
};
